import { useQuery } from '@tanstack/react-query';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import useErrorHandler from '../../../hooks/useErrorHandler';
import { useTenant } from '../../../contexts/TenantContext';

/**
 * Who the signed-in user is on the dashboard: `{ isAdmin, providerId }` (docs/MULTI_PROVIDER.md).
 * A user who is no member of staff gets 403 (DEC-0010), and its snackbar, before any other call.
 *
 * Kept only while the dashboard is open (`gcTime: 0`): after signing out and in as somebody else,
 * an answer cached from before would be the other user's.
 */
const useGetStaffMe = () => {
  const { tenantId } = useTenant();
  const { handleError } = useErrorHandler();

  return useQuery({
    queryKey: ['staffMe', tenantId],
    queryFn: async () => {
      try {
        const response = await apiClient.get(`/v1/tenants/${tenantId}/staff/me`);
        return response.data;
      } catch (error) {
        handleError(error, Routes.DASHBOARD);
        throw error;
      }
    },
    enabled: !!tenantId,
    staleTime: Infinity,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
};

export default useGetStaffMe;
